import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { getHealth } from "@/lib/api";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

import Layout from "@/components/layout/Layout";
import LandingPage from "@/pages/LandingPage";
import InfoPage from "@/pages/InfoPage";
import WhyAvasaDetailPage from "@/pages/WhyAvasaDetailPage";
import AccountSecurityPage from "@/pages/AccountSecurityPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import OwnerSubscriptionPage from "@/pages/owner/OwnerSubscriptionPage";
import AdminSubscriptionPage from "@/pages/admin/AdminSubscriptionPage";
import AdminAccountsPage from "@/pages/admin/AdminAccountsPage";
import SearchPage from "@/pages/SearchPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import MiniSitePage from "@/pages/MiniSitePage";
import MiniSitePropertiesPage from "@/pages/MiniSitePropertiesPage";
import PaymentReturnPage from "@/pages/PaymentReturnPage";
import NotificationsPage from "@/pages/NotificationsPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import CustomerProfilePage from "@/pages/customer/CustomerProfilePage";
import CustomerBookingsPage from "@/pages/customer/CustomerBookingsPage";
import CustomerSurveysPage from "@/pages/customer/CustomerSurveysPage";
import CustomerFavoritesPage from "@/pages/customer/CustomerFavoritesPage";
import CustomerMessagesPage from "@/pages/customer/CustomerMessagesPage";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import OwnerPropertiesPage from "@/pages/owner/OwnerPropertiesPage";
import OwnerBookingsPage from "@/pages/owner/OwnerBookingsPage";
import OwnerSurveysPage from "@/pages/owner/OwnerSurveysPage";
import OwnerTenantsPage from "@/pages/owner/OwnerTenantsPage";
import OwnerWaitlistPage from "@/pages/owner/OwnerWaitlistPage";
import OwnerBillingPage from "@/pages/owner/OwnerBillingPage";
import OwnerBillingDetailPage from "@/pages/owner/OwnerBillingDetailPage";
import OwnerMetersPage from "@/pages/owner/OwnerMetersPage";
import OwnerBillingComponentsPage from "@/pages/owner/OwnerBillingComponentsPage";
import OwnerRefundsPage from "@/pages/owner/OwnerRefundsPage";
import OwnerPromosPage from "@/pages/owner/OwnerPromosPage";
import OwnerFinancePage from "@/pages/owner/OwnerFinancePage";
import OwnerReviewsPage from "@/pages/owner/OwnerReviewsPage";
import OwnerMessagesPage from "@/pages/owner/OwnerMessagesPage";
import PropertyNewPage from "@/pages/owner/PropertyNewPage";
import PropertyEditPage from "@/pages/owner/PropertyEditPage";
import PropertyViewPage from "@/pages/owner/PropertyViewPage";
import OwnerProfilePage from "@/pages/owner/OwnerProfilePage";
import OwnerMiniSitePage from "@/pages/owner/OwnerMiniSitePage";
import OwnerPaymentSettingsPage from "@/pages/owner/OwnerPaymentSettingsPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPropertyModerationPage from "@/pages/admin/AdminPropertyModerationPage";
import AdminBookingsPage from "@/pages/admin/AdminBookingsPage";
import AdminRefundsPage from "@/pages/admin/AdminRefundsPage";
import AdminPromosPage from "@/pages/admin/AdminPromosPage";
import AdminCommissionsPage from "@/pages/admin/AdminCommissionsPage";
import AdminAgreementsPage from "@/pages/admin/AdminAgreementsPage";
import AdminReviewsPage from "@/pages/admin/AdminReviewsPage";
import AdminSiteCmsPage from "@/pages/admin/AdminSiteCmsPage";
import AdminPropertyDetailPage from "@/pages/admin/AdminPropertyDetailPage";
import LocationDemoPage from "@/pages/LocationDemoPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  useEffect(() => {
    getHealth()
      .then((data) => console.log("AVASA API health:", data))
      .catch((e) => console.error("Health check failed:", e));
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors offset={72} />
          <Routes>
            <Route path="/properti/:slug" element={<MiniSitePage />} />
            <Route path="/properti/:slug/hunian" element={<MiniSitePropertiesPage />} />
            <Route element={<Layout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/location-demo" element={<LocationDemoPage />} />
              <Route path="/tentang-kami" element={<InfoPage />} />
              <Route path="/syarat-ketentuan" element={<InfoPage />} />
              <Route path="/kebijakan-privasi" element={<InfoPage />} />
              <Route path="/hubungi-kami" element={<InfoPage />} />
              <Route path="/kenapa-avasa/:key" element={<WhyAvasaDetailPage />} />
              <Route path="/property/:id" element={<PropertyDetailPage />} />
              <Route path="/payment/return" element={<PaymentReturnPage />} />
              <Route
                path="/notifications"
                element={
                  <ProtectedRoute>
                    <NotificationsPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/lupa-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route
                path="/customer"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/profile"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/bookings"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerBookingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/surveys"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerSurveysPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/favorites"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerFavoritesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/messages"
                element={
                  <ProtectedRoute role="customer">
                    <CustomerMessagesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/properties"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerPropertiesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/properties/new"
                element={
                  <ProtectedRoute role="owner">
                    <PropertyNewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/properties/:id"
                element={
                  <ProtectedRoute role="owner">
                    <PropertyViewPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/properties/:id/edit"
                element={
                  <ProtectedRoute role="owner">
                    <PropertyEditPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/profile"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/minisite"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerMiniSitePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/payment-settings"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerPaymentSettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/bookings"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerBookingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/surveys"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerSurveysPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/tenants"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerTenantsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/waitlist"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerWaitlistPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/billing"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerBillingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/billing/components"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerBillingComponentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/billing/:id"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerBillingDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/meters"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerMetersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/messages"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerMessagesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/refunds"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerRefundsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/promos"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerPromosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/finance"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerFinancePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/reviews"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerReviewsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/properties"
                element={
                  <ProtectedRoute role="admin">
                    <AdminPropertyModerationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/bookings"
                element={
                  <ProtectedRoute role="admin">
                    <AdminBookingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/refunds"
                element={
                  <ProtectedRoute role="admin">
                    <AdminRefundsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/promos"
                element={
                  <ProtectedRoute role="admin">
                    <AdminPromosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/commissions"
                element={
                  <ProtectedRoute role="admin">
                    <AdminCommissionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/agreements"
                element={
                  <ProtectedRoute role="admin">
                    <AdminAgreementsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/reviews"
                element={
                  <ProtectedRoute role="admin">
                    <AdminReviewsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/cms"
                element={
                  <ProtectedRoute role="admin">
                    <AdminSiteCmsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/admins"
                element={
                  <ProtectedRoute role="admin">
                    <AdminUsersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subscription"
                element={
                  <ProtectedRoute role="admin">
                    <AdminSubscriptionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/accounts"
                element={
                  <ProtectedRoute role="admin">
                    <AdminAccountsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/subscription"
                element={
                  <ProtectedRoute role="owner">
                    <OwnerSubscriptionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pengaturan-akun"
                element={
                  <ProtectedRoute>
                    <AccountSecurityPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/properties/:id"
                element={
                  <ProtectedRoute role="admin">
                    <AdminPropertyDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
